// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"fea14ca9","519":"f6c61cbb","700":"16ad494a"}[chunkId] + ".chunk.css";
};